import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { CardAvatar } from "../../card/CardAvatar";
import { UploadAvatar } from "../../fields/UploadAvatar";

interface JourneyProfileEditorProps {
  name: string;
  setName: (value: string) => void;
  subtitle?: string;
  setSubtitle: (value: string) => void;
  avatar: string;
  setAvatar: (value: string) => void;
  description?: string;
  setDescription: (value: string) => void;
}

export function JourneyProfileEditor({
  name,
  setName,
  subtitle,
  setSubtitle,
  avatar,
  setAvatar,
  description,
  setDescription,
}: JourneyProfileEditorProps) {
  const [uploadError, setUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleUploading = (uploading: boolean) => {
    setIsUploading(uploading);
  };

  const handleAvatarUpload = (url: string) => {
    setAvatar(url);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <CardAvatar src={avatar} />
        <Box flex={1} ml={2}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <TextField
            label="Subtitle"
            value={subtitle ?? ""}
            onChange={(e) => setSubtitle(e.target.value)}
            variant="outlined"
            margin="normal"
            fullWidth
          />
        </Box>
      </Box>

      <Box mb={2}>
        <UploadAvatar
          value={avatar}
          setValue={(fieldName, newUrl) => handleAvatarUpload(newUrl)}
          setError={() => {}}
          onError={(err) => setUploadError(err)}
          onUploading={handleUploading}
        >
          <Button variant="contained" fullWidth disabled={isUploading}>
            {isUploading ? "Uploading..." : "Upload new picture"}
          </Button>
        </UploadAvatar>

        {uploadError && <Typography color="error">{uploadError}</Typography>}
      </Box>
      <Box mb={2}>
        <TextField
          label="Description"
          value={description ?? ""}
          onChange={(e) => setDescription(e.target.value)}
          variant="outlined"
          margin="normal"
          fullWidth
          multiline
          minRows={3}
        />
      </Box>
    </Box>
  );
}
